import React, {useState, useEffect} from 'react';
import SettingsService from '../../app/services/SettingsService';

import Heading from '../../app/components/heading';
import Button from '../../app/components/button';

import Check from '../../app/assets/images/icons/svg/check';

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

const PlanChoice = (props) => {

  const token = props.token;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const addToNewsletter = async () => {
    setLoading(true);
    const subscribeMember = await SettingsService.subscribeMember(email, token);

    if(subscribeMember.data.subscribed){
      setLoading(false);
      window.location.reload();
    }else{
      alert("Something went wrong please contact support");
    }
  }

  const billingUrl = async () => {
    try{
      const billingUrl = await SettingsService.getBillingUrl(token);
      window.open(billingUrl.data)
    }catch(err){
      alert("We are very sorry, there was an error on our side. We could not generate the billing URL. Please contact the support");
    }
  }

  useEffect(() => {
    var tooltipSpan = document.getElementById('tooltip-span');
    document.onmousemove = function (e) {
        var x = e.clientX,
            y = e.clientY;
            tooltipSpan.style.top = (y + 20) + 'px';
            tooltipSpan.style.left = (x + 20) + 'px';
    };
  }, [])

  return(
    <div className="">
      <div className="flex w-full h-full items-center justify-center">
        <div className="bg-white md:min-w-[500px] min-w-full py-10 md:px-8 px-4">
          <div className="text-center mb-8">
            <Heading
              title="Select your pricing plan"
              headingSize="lg"
            />
            <p>Choose your pricing plan and start using Accessibly now.</p>
          </div>
          <div className="md:flex block">
            <div className="rounded border border-ac py-10 px-5 bg-lightBlue w-full md:max-w-[350px] mr-4 relative md:mb-0 mb-4">
              <p className="text-sm font-semibold text-white bg-green rounded-b-full py-5 px-2 max-w-[74px] text-center leading-[7px] absolute -top-3 right-10">Save <span className="text-lg">30%</span></p>
              <Heading
                title="Premium"
                headingSize="lg"
                className="font-semibold"
              />
              <p className="mb-4 mt-3">Choose your pricing plan and start using Accessibly now.</p>
              <p className="text-lg text-black font-light mb-0"><span className="font-semibold">$25</span>/month</p>
              <p>Yearly plan available!</p>
              {/* list */}
              <div className="h-[220px]">
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Update the look of widget as you wish</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Custom placement</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>More features = Increased compliance</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Change the default widget language</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Update widget position</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Newest features – Skip to Content, Go to Main Menu, Go to Footer</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>...and many more!</p>
              </div>


              <hr className="mt-5 mb-4"/>
              <p className='font-semibold text-sm text-black text-center mb-2'>Get 30% discount for the first 6 months! Use code: <span className="text-ac">WORDPRESS30</span></p>
              <Button customClass="w-full" label="Start Accessibly Premium" color="indigo" onClick={() => billingUrl()} />
            </div>

            <div className="rounded border border-gray py-10 px-5 w-full md:max-w-[350px]">
              <Heading
                title="Free"
                headingSize="lg"
                className="font-semibold"
              />
              <p className="mb-4 mt-3">Provide starter accessibility features for your site visitors.</p>
              <p className="text-lg text-black font-light mb-0"><span className="font-semibold">$0</span></p>
              <p className="h-[19.5px]"></p>
              {/* list */}
              <div className="h-[220px]">
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Enable the Accessibly widget</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Have the basic features necessary for your visitors</p>
                <p className="flex items-center mb-1"><span className="mr-2"><Check/></span>Default Accessibility statement</p>

              </div>

              <div className="mt-[12px]">
                <label className={`mb-2 block text-sm text-gray-700 font-semibold w-full`}>
                  Enter email to activate Free Plan:
                </label>
                <input
                  type="text"
                  value={email}
                  className={`outline-none border border-gray-300 pl-3 text-sm py-2 w-full`}
                  placeholder="email@example.com"
                  onChange={(val) => setEmail(val.target.value)}
                />
              </div>
              <Button
                customClass="w-full mt-2 tooltip-info"
                label="Start Free Plan"
                color="transparent"
                disabled={!validateEmail(email) || loading}
                onClick={() => addToNewsletter()}
                loading={loading}
              >
                {!validateEmail(email) ? <span id="tooltip-span">Please enter an email adress in the field above.</span> : null}
              </Button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PlanChoice;
